import { render, staticRenderFns } from "./DoctorData.vue?vue&type=template&id=ead7e452&scoped=true&"
import script from "./DoctorData.vue?vue&type=script&lang=js&"
export * from "./DoctorData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead7e452",
  null
  
)

export default component.exports